import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { useCallback, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Url from 'urlinator/Url';
// @ts-expect-error package not converted to TS
import HubSpotOnlyAppCookieLogin from 'Nabisco/app/HubSpotOnlyAppCookieLogin';
import LoginDao from '../../data/LoginDao';
import { useRedirect } from '../../hooks/useRedirect';
const loginDao = new LoginDao();
export const useConfirmationLanding = loginType => {
  const [error, setError] = useState();
  const {
    search
  } = useLocation();
  const appCookieLogin = useMemo(() => {
    const asyncCall = {
      MICROSOFT: loginDao.microsoftLogin.bind(loginDao),
      GOOGLE: loginDao.googleLogin.bind(loginDao)
    };
    return new HubSpotOnlyAppCookieLogin({
      loginRequest: asyncCall[loginType],
      passThroughFallback: true
    });
  }, [loginType]); // parse query params

  const credentials = useMemo(() => {
    const qp = new URLSearchParams(search);

    const _Object$fromEntries = Object.fromEntries([...qp]),
          {
      state
    } = _Object$fromEntries,
          parsedParams = _objectWithoutPropertiesLoose(_Object$fromEntries, ["state"]);

    const URL_LOADED_LOCAL = Url.loaded.local;
    const params = Object.assign({}, parsedParams, {}, JSON.parse(state || '{}'), {}, URL_LOADED_LOCAL ? {
      redirectToLocal: true
    } : {});

    if (loginType === 'MICROSOFT') {
      return Object.assign({}, params, {
        authCode: parsedParams.code,
        code: undefined
      });
    }

    return params;
  }, [search, loginType]); // response and redirect handlers

  const {
    redirectByStatus
  } = useRedirect(credentials); // onLoad handler

  const onLoad = useCallback(() => {
    appCookieLogin.login(credentials).then(responses => {
      const response = responses[0];
      redirectByStatus(response);
    }).catch(err => {
      const type = err && err.responseJSON && err.responseJSON.status;
      setError(type || 'LOGIN_UNAVAILABLE');
    });
  }, [setError, appCookieLogin, redirectByStatus, credentials]);
  return {
    error,
    onLoad
  };
};